// src/listeners/notifySessionWasTransferredEventListener.ts
import {useAuthStore} from "@src/stores/auth";
import {useChatSessionStore} from "@src/stores/chatSession";
import {db} from "@src/services/db";
import "@src/services/echo";

export const NotifySessionWasTransferredListener = () => {
    const auth = useAuthStore();
    const sessionStore = useChatSessionStore();

    const userId = auth.user?.id;
    if (!userId) return;

    // @ts-ignore
    window.websockets
        .private(`user.${userId}`)
        .listen(".NotifySessionWasTransferredEvent", async (event: any) => {
            try {
                const sessionId = Number(event?.session?.id);
                if (!sessionId) return;

                await db.sessions.delete(sessionId)

                if ((sessionStore.selectedSession as any)?.id === sessionId) {
                    sessionStore.clearSession();
                }
            } catch (e) {
                console.error("❌ erro NotifySessionWasTransferredEvent listener", e);
            }
        });
};